import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  filterByGoalId: '',
  filterByCommitmentId: '',
  filterByTscId: '',
  time_updated_every_sec: null,
  now_updated_every_min: null,
  activeSessionIndex: null,
  activeSession: null,
  nextSession: null,
  timer_status: null,
  activeSessionTimeUntilEnd: null,
  nextSessionTimeUntilStart: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
